import { useCdnImg } from "@webplatform/cdn-image";
function useMediaAsset() {
  const { generateUrl } = useCdnImg();
  return {
    getAssetUrl(asset, modifiers = {}) {
      if (!asset)
        return null;
      return generateUrl(asset, modifiers);
    }
  };
}
export {
  useMediaAsset as default
};
